import React from 'react';
import MobileHero from './components/MobileHero';
import MobileServices from './components/MobileServices';
import MobileTechnologies from './components/MobileTechnologies';
import MobileProcess from './components/MobileProcess';
// import WhyChooseSection from '../../../components/WhyChooseSection';
import WhyChooseUs from '../SoftwareDevelopment/components/WhyChooseUs';
// import MobileWhyChoose from './components/MobileWhyChoose';
// import MobilePortfolio from './components/MobilePortfolio';
import ContactFormWidget from '../../../components/ContactFormWidget';
import Footer from '../../../components/Footer';

const MobileApps = () => {
  return (
    <div className="mobile-apps-page">
      <MobileHero />
      <MobileServices />
      <MobileProcess />
      <MobileTechnologies />
      <WhyChooseUs />
      {/* <MobileWhyChoose />
      <MobilePortfolio /> */}
      <ContactFormWidget />
      <Footer />
    </div>
  );
};

export default MobileApps; 